module.exports = __webpack_public_path__ + "img/block.eb2721ac.svg";